import React from "react";

export const CustomField = ({ input, label, placeholder, type, className, meta: { touched, error, warning } }) => (

    <div>
        <input {...input} placeholder={label} type={type} className={className}/>
        <span className="font-12 color-danger">{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</span>
    </div>
);